export * from './vermerke.component';
export * from './vermerke.component.module';